import React, {useEffect} from 'react';
import {useDownloadURL} from "react-firebase-hooks/storage";
import {firebaseStorage, storageRef} from "../firebase/client-app";

const ShowImageSmall = ({imageDetail, selectedImage}) => {
    const [value, loading, error] = useDownloadURL(storageRef(firebaseStorage, imageDetail?.thumbnail));

    let modes = {
        'fill': 'cover',
        'fit': 'contain'
    };
    let size = modes['fit'] || 'contain';

    let defaults = {
        height: 100,
        width: 100,
        backgroundColor: 'bg-white',
    };

    return (
        <>
            {!loading && value &&
                <div style={{
                    ...defaults, backgroundSize: size,
                    backgroundPosition: 'center center',
                    backgroundRepeat: 'no-repeat',
                    backgroundImage: `url("${value}")`
                }}
                     className={`${(imageDetail?.id === selectedImage?.id) ? 'border-blue-600 border-2 bg-blue-100' : 'border-gray-200 bg-white'} text-center hover:bg-neutral-400 border rounded m-1 cursor-pointer`}/>

            }

            {loading && !value &&
                <div
                    className="border-gray-200 bg-white text-center hover:bg-neutral-400 border rounded m-1 cursor-pointer">
                    <div style={{
                        ...defaults, backgroundSize: size,
                        backgroundPosition: 'center center',
                        backgroundRepeat: 'no-repeat',
                    }}/>
                </div>
            }
        </>
    )
}

export default ShowImageSmall
